import React from 'react';
import { bindActionCreators } from 'redux';

import { store } from 'redux/store';

export function useAction(actionCreator) {
  return React.useMemo(() => bindActionCreators(actionCreator, store.dispatch), [actionCreator]);
}
